import {AbstractControl, ValidationErrors} from '@angular/forms';
import {UserRolesEnum} from '../user-roles.enum';
import {HealthCenterShort} from '../../../../pages/health-center/services/http/health-center-short';

export function practitionerHealthCentreValidator(control: AbstractControl): ValidationErrors | null {
  if (control.get('role')?.value === UserRolesEnum.PRACTITIONER) {
    if (!(control.get('healthCenter')?.value instanceof HealthCenterShort)) {
      control.get('healthCenter')?.setErrors({incorrect: true});
    } else {
      control.get('healthCenter')?.setErrors(null);
    }
  } else {
    control.get('healthCenter')?.setErrors(null);
  }
  return null;
}
